import React from "react";
import {
    Button,
    Card,
    CardContent,
    Collapse,
    Grid,
    MenuItem,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { STATUS_OPTIONS } from "./constants";

const BugReportFilters = ({
    open = false,
    filters = {},
    status = "open",
    onFiltersChange = () => {},
    onStatusChange = () => {},
    onClearFilters = () => {},
}) => {
    const handleFilterFieldChange = (fieldName, fieldValue) => {
        onFiltersChange({
            ...filters,
            [fieldName]: fieldValue,
        });
    };

    return (
        <Collapse in={open}>
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h4">Filtros</Typography>
                        <Button size="small" onClick={onClearFilters}>Limpiar filtros</Button>
                    </Stack>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Estado"
                                value={status}
                                onChange={(event) => onStatusChange(event.target.value)}
                            >
                                {STATUS_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Versión de la app"
                                placeholder="2.1"
                                value={filters.app_version || ""}
                                onChange={(event) => handleFilterFieldChange("app_version", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Pantalla"
                                placeholder="/trips"
                                value={filters.screen || ""}
                                onChange={(event) => handleFilterFieldChange("screen", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="number"
                                label="ID de empresa"
                                value={filters.company_id || ""}
                                onChange={(event) => handleFilterFieldChange("company_id", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Reportado desde"
                                InputLabelProps={{ shrink: true }}
                                value={filters.from || ""}
                                onChange={(event) => handleFilterFieldChange("from", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Reportado hasta"
                                InputLabelProps={{ shrink: true }}
                                value={filters.to || ""}
                                onChange={(event) => handleFilterFieldChange("to", event.target.value)}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Collapse>
    );
};

export default BugReportFilters;
